import Api from './api';

export default {
  getSyncLogs: (data) => Api.get('patreon/logs', data),
  getUnsynced: () => Api.get('patreon/unsynced'),
  getSalaries: (data) => Api.get('patreon/salaries', data),
  syncUser: (userEmail, patreonEmail) => Api.post('patreon/sync', { userEmail, patreonEmail }),
};
